import CtaBox from 'components/cta-box/cta-box';
import CtaBoxActions from 'components/cta-box/cta-box-actions';
import CtaBoxContent from 'components/cta-box/cta-box-content';
import CtaBoxHint from 'components/cta-box/cta-box-hint';
import CtaBoxMedia from 'components/cta-box/cta-box-media';
import CtaBoxText from 'components/cta-box/cta-box-text';
import CtaBoxTitle from 'components/cta-box/cta-box-title';

export { CtaBox, CtaBoxActions, CtaBoxContent, CtaBoxHint, CtaBoxMedia, CtaBoxText, CtaBoxTitle };
